<div
  class="row badge-wrapper"
  [attr.size]="size"
  [attr.tone]="tone"
  [attr.type]="type"
>
  <rr-icon *ngIf="icon" [name]="icon"></rr-icon>
  <div class="label-container">
    <ng-content></ng-content>
  </div>
  <rr-icon
    *ngIf="type == 'tag'"
    class="pointer"
    name="close"
    (click)="click.emit()"
  ></rr-icon>
</div>
